<template>
  <b-container fluid class="d-flex flex-column vh-100 p-0">
    <div class="p-3 bg-primary text-white"><h4>SafeNot</h4></div>
    
    <div v-if="!code || !email">
      <h3>Invalid Link</h3>
    </div>

    <b-row align-v="center" align-h="center" class="d-flex bg flex-grow-1 m-0" v-else>
    <b-col cols="5" xl="3">
        <b-card header="Reset Password" header-bg-variant="primary" header-text-variant="white" border-variant="dark">
        <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
        <b-card-text>
            <ValidationObserver v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(reset)">
                    <b-form-group>
                        <b-input disabled :value="email"></b-input>
                    </b-form-group>
                    
                    <b-form-group label="Password">
                        <ValidationProvider name="Password" :rules="{ required: true, min: 6, regex: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/ }" vid="password" v-slot="{ errors, failedRules }">
                            <b-input type="password" v-model="password" :state="errors[0] ? false : null"></b-input>
                            <b-form-invalid-feedback v-if="failedRules.regex">Password must contain an uppercase character, lowercase character, a digit, and a non-alphanumeric character</b-form-invalid-feedback>
                            <b-form-invalid-feedback v-else>{{ errors[0] }}</b-form-invalid-feedback>
                        </ValidationProvider>
                    </b-form-group>

                    <b-form-group label="Confirm Password">
                        <ValidationProvider name="Confirm Password" rules="required|confirmed:password" v-slot="{ errors }">
                            <b-input type="password" v-model="confirm_password" :state="errors[0] ? false : null"></b-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </ValidationProvider>
                    </b-form-group>

                    <b-button type="submit">Save</b-button>
                </b-form>
            </ValidationObserver>
        </b-card-text>
        </b-card>
    </b-col>
    </b-row>
  </b-container>
</template>
<script>
import axios from 'axios';
import { ValidationProvider, ValidationObserver, setInteractionMode } from 'vee-validate';

setInteractionMode('lazy');

export default {
    components: { ValidationProvider, ValidationObserver },
    data() {
      return {
        error: '',
        code: '',
        email: '',
        password: '',
        confirm_password: ''
      }
    },
    methods: {
      reset() {
        this.error = '';

        axios.post('/api/account/reset', {
            code: this.code,
            email: this.email,
            password: this.password
        })
        .then(res => {
          if (res.data !== '') {
            this.$store.commit('login', res.data);
          }
          this.$router.push('/');
        })
        .catch(() => {
          this.error = 'Failed to reset password';
        })
      }
    },
    created() {
        this.code = this.$route.query.code;
        this.email = this.$route.query.email;
    }
}
</script>
<style scoped>
  .bg {
    background-image: url("../assets/Back.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;  
  }
</style>